import { useParams, useNavigate } from "react-router-dom";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Wallet, Receipt, FileText, ArrowLeft } from "lucide-react";
import ComprobantesPago from "./ComprobantesPago";
import ComprobantesOficina from "./ComprobantesOficina";

const submodulos = [
  { id: "comprobantes-pago", title: "Comprobantes de Pago", description: "Registro de comprobantes de pago", icon: Receipt, color: "emerald" },
  { id: "comprobantes-pago-catastro", title: "Comprobantes de Pago Catastro", description: "Pagos procesados de la oficina de Catastro", icon: FileText, color: "blue" },
  { id: "comprobantes-pago-desarrollo-urbano", title: "Comprobantes de Pago Desarrollo Urbano", description: "Pagos procesados de la oficina de Desarrollo Urbano", icon: FileText, color: "violet" }
];

const RecaudacionesPage = () => {
  const { submodulo } = useParams();
  const navigate = useNavigate();

  if (!submodulo) {
    return (
      <div className="space-y-6" data-testid="recaudaciones-page">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
            <Wallet className="w-6 h-6 text-emerald-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>Recaudaciones</h1>
            <p className="text-slate-500">Control de ingresos y pagos tributarios</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {submodulos.map((sub) => {
            const Icon = sub.icon;
            return (
              <Card key={sub.id} className="card-hover cursor-pointer group" onClick={() => navigate(`/recaudaciones/${sub.id}`)} data-testid={`submodulo-${sub.id}`}>
                <CardContent className="p-6">
                  <div className={`w-12 h-12 bg-${sub.color}-100 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                    <Icon className={`w-6 h-6 text-${sub.color}-600`} />
                  </div>
                  <h3 className="font-semibold text-slate-900 mb-1">{sub.title}</h3>
                  <p className="text-sm text-slate-500">{sub.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    );
  }

  const currentSubmodulo = submodulos.find(s => s.id === submodulo);

  return (
    <div className="space-y-6" data-testid="recaudaciones-submodulo">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate("/recaudaciones")} className="hover:bg-slate-100" data-testid="btn-volver">
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
          <Wallet className="w-6 h-6 text-emerald-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>{currentSubmodulo?.title || "Recaudaciones"}</h1>
          <p className="text-slate-500">{currentSubmodulo?.description}</p>
        </div>
      </div>

      {submodulo === "comprobantes-pago" && <ComprobantesPago />}
      {submodulo === "comprobantes-pago-catastro" && (
        <ComprobantesOficina
          oficina="Catastro"
          endpointParam="oficina=Catastro&estatus=Pagado"
          emptyMessage="No hay comprobantes de pago de Catastro registrados"
          testIdPrefix="catastro"
        />
      )}
      {submodulo === "comprobantes-pago-desarrollo-urbano" && (
        <ComprobantesOficina
          oficina="Desarrollo Urbano"
          endpointParam="oficina=Desarrollo Urbano&estatus=Pagado"
          emptyMessage="No hay comprobantes de pago de Desarrollo Urbano registrados"
          testIdPrefix="desarrollo-urbano"
        />
      )}
    </div>
  );
};

export default RecaudacionesPage;
